<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol>
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Fleet Fee Distribution</span></li>
                    </ol>
                </div>
                <div class="content-title">
                    <h2>Fleet Fee Distribution</h2>
                </div>
                <hr>

                <div class="list-holder">
                    <div class="tools">
                        <div class="search mg-right-auto">
                            <span class="fee-hint">
                                How each booking's app fee is split between the Fleet Operator, the driver and OKITO.
                                A default applies to every fleet of its type; an override replaces it for one Fleet Operator.
                            </span>
                        </div>
                        <div class="profile-actions">
                            <select class="form-select fee-filter" [(ngModel)]="filterType" aria-label="Filter by service type">
                                <option value="">All service types</option>
                                <option *ngFor="let type of fleetTypes" [value]="type">{{ fleetTypeLabel(type) }}</option>
                            </select>
                            <button class="btn btn-sm btn-default" style="min-width: 100px;"
                                (click)="openAdd(formModal)" *ngIf="canManage">Add</button>
                        </div>
                    </div>
                    <div class="list">
                        <table>
                            <thead>
                                <tr>
                                    <th>Service Type</th>
                                    <th>Applies To</th>
                                    <th>Fleet Operator Share</th>
                                    <th>Driver Incentive</th>
                                    <th>OKITO Keeps</th>
                                    <th>Status</th>
                                    <th>Last Updated</th>
                                    <th *ngIf="canManage">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="visibleDistributions.length !== 0; else noRecords">
                                    <tr *ngFor="let row of visibleDistributions">
                                        <td>{{ fleetTypeLabel(row.serviceType) }}</td>
                                        <td>
                                            <span *ngIf="!row.fleetId">All {{ fleetTypeLabel(row.serviceType) }} fleets (default)</span>
                                            <span *ngIf="row.fleetId">{{ row.fleetName || 'Unknown fleet' }}</span>
                                        </td>
                                        <td>&#8369;{{ row.operatorShareAmount | number:'1.2-2' }}</td>
                                        <td>&#8369;{{ row.driverIncentiveAmount | number:'1.2-2' }}</td>
                                        <td>
                                            <span *ngIf="okitoShare(row) !== null">&#8369;{{ okitoShare(row) | number:'1.2-2' }}</span>
                                            <span *ngIf="okitoShare(row) === null" class="fee-muted"
                                                title="The service is charged a percentage, so the split is capped to the fee collected per booking.">The rest</span>
                                        </td>
                                        <td>
                                            <span [class.fee-enabled]="row.isActive" [class.fee-muted]="!row.isActive">
                                                {{ row.isActive ? 'Enabled' : 'Disabled' }}
                                            </span>
                                        </td>
                                        <td>{{ row.dateUpdated | amFromUtc | amLocal | amDateFormat: 'MM-DD-YYYY h:mm A' }}</td>
                                        <td *ngIf="canManage" class="fee-actions">
                                            <a (click)="openEdit(row, formModal)">Edit</a>
                                            <a (click)="confirmStatus(row, statusModal)">{{ row.isActive ? 'Disable' : 'Enable' }}</a>
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-template #noRecords>
                                    <tr>
                                        <td [attr.colspan]="canManage ? 8 : 7" class="no-records-msg">
                                            <h6 class="ponds-contents-med-bold" *ngIf="isLoading">Loading…</h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'unsupported'">
                                                Not available on this environment yet.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'failed'">
                                                Connection not available. Please try again.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'none'">
                                                No records found
                                            </h6>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<ng-template #formModal let-modal class="modal">
    <div class="modal-header">
        <h5 class="modal-title">{{ editing ? 'Edit Fee Distribution' : 'Add Fee Distribution' }}</h5>
        <button type="button" class="btn-close" aria-label="Close" [disabled]="isSaving" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="form-item">
            <label class="form-label">Service Type</label>
            <select class="form-select" [(ngModel)]="form.serviceType" (ngModelChange)="onServiceTypeChange()"
                [disabled]="!!editing">
                <option *ngFor="let type of fleetTypes" [ngValue]="type">{{ fleetTypeLabel(type) }}</option>
            </select>
        </div>

        <div class="form-item">
            <label class="form-label">Applies To</label>
            <select class="form-select" [(ngModel)]="form.scope" [disabled]="!!editing">
                <option value="default">All {{ fleetTypeLabel(form.serviceType) }} fleets (default)</option>
                <option value="fleet">One Fleet Operator (override)</option>
            </select>
        </div>

        <div class="form-item" *ngIf="form.scope === 'fleet'">
            <label class="form-label">Fleet Operator</label>
            <input *ngIf="editing" type="text" class="form-control" [value]="editing.fleetName || 'Unknown fleet'" disabled>
            <select *ngIf="!editing" class="form-select" [(ngModel)]="form.fleetId" [disabled]="isLoadingFleets">
                <option value="">{{ isLoadingFleets ? 'Loading…' : 'Select a Fleet Operator' }}</option>
                <option *ngFor="let fleet of fleetOptions" [value]="fleet.fleetId">
                    {{ fleet.operatorName }} ({{ fleet.fleetCode }})
                </option>
            </select>
            <small class="fee-hint" *ngIf="!editing && !isLoadingFleets && fleetOptions.length === 0">
                No {{ fleetTypeLabel(form.serviceType) }} Fleet Operators yet.
            </small>
        </div>

        <div class="form-item">
            <label class="form-label">Fleet Operator Share (&#8369;)</label>
            <input type="number" class="form-control" min="0" step="0.01" placeholder="e.g. 15.00"
                [(ngModel)]="form.operatorShareAmount">
            <small class="fee-hint">Credited to the Fleet Operator's wallet per completed booking.</small>
        </div>

        <div class="form-item">
            <label class="form-label">Driver Incentive (&#8369;)</label>
            <input type="number" class="form-control" min="0" step="0.01" placeholder="e.g. 5.00"
                [(ngModel)]="form.driverIncentiveAmount">
            <small class="fee-hint">
                Credited back to the driver's top-up wallet, once the driver has topped up at least &#8369;100.
            </small>
        </div>

        <p class="fee-hint" *ngIf="formFlatFee !== null">
            App fee: &#8369;{{ formFlatFee | number:'1.2-2' }} flat. OKITO keeps
            &#8369;{{ formOkitoShare | number:'1.2-2' }}.
        </p>
        <p class="fee-hint" *ngIf="formFlatFee === null">
            This service is charged a percentage, not a flat fee. The shares are capped to the fee collected on each booking.
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" [disabled]="isSaving" (click)="modal.dismiss('Cross click')">Cancel</button>
        <button type="button" class="btn btn-default" [disabled]="isSaving" (click)="save(successModal)">
            {{ editing ? 'Save' : 'Add' }}
        </button>
    </div>
</ng-template>

<ng-template #statusModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body" *ngIf="statusTarget">
        <p>
            Are you sure you want to {{ statusTarget.isActive ? 'disable' : 'enable' }} the
            <strong>{{ fleetTypeLabel(statusTarget.serviceType) }}</strong> fee distribution for
            <strong>{{ statusTarget.fleetId ? (statusTarget.fleetName || 'this Fleet Operator') : 'all fleets (default)' }}</strong>?
        </p>
        <p class="fee-hint" *ngIf="statusTarget.isActive && statusTarget.fleetId">
            The fleet will use the {{ fleetTypeLabel(statusTarget.serviceType) }} default instead.
        </p>
        <p class="fee-hint" *ngIf="statusTarget.isActive && !statusTarget.fleetId">
            Fleets without an override will no longer get a share: OKITO keeps the whole app fee.
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default" [disabled]="isSaving" (click)="updateStatus(successModal)">
            Yes, {{ statusTarget?.isActive ? 'Disable' : 'Enable' }}
        </button>
    </div>
</ng-template>

<ng-template #successModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body success-body">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>{{ successMessage }}</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>
</ng-template>
